import SearchBox from 'components/SearchBox';
import {
  ComponentProps,
  forwardRef,
  useImperativeHandle,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';

const PlantingGroupSearchFilter = forwardRef(
  (props: ComponentProps<typeof SearchBox>, ref: any) => {
    const [plantingGroupSearchTerm, setPlantingGroupSearchTerm] = useState(
      props?.defaultValue || '',
    );
    const { t } = useTranslation();

    // Expose clearSearch method to parent components
    useImperativeHandle(ref, () => ({
      clearSearch: () => setPlantingGroupSearchTerm(''),
    }));

    return (
      <SearchBox
        ref={ref}
        value={plantingGroupSearchTerm}
        onChange={(e) => setPlantingGroupSearchTerm(e.target?.value)}
        placeholder={t('dashboard.plantingGroupNamePlaceholder')}
        onSearch={props.onSearch}
        onClear={props.onClear}
        disabled={props.disabled}
        allowClear
        {...props}
      />
    );
  },
);

PlantingGroupSearchFilter.displayName = 'PlantingGroupSearchFilter';

export default PlantingGroupSearchFilter;
